import { Logger } from '../../../../common/utils/logger';
import { getIndexedDBOpenOverride, getIndexedDBOpenOverrideEventOnly } from '../indexed-db-open-override';

interface IndexedDbPassthroughConfig {
	performConsentChecks: boolean;
}

export const createIndexedDBPassthrough = async (config: IndexedDbPassthroughConfig): Promise<void> => {
	const indexedDB = window.indexedDB;

	if (!indexedDB) {
		Logger.warn('No IndexedDB capabilities found');
		return;
	}

	if (typeof indexedDB.open !== 'function') {
		Logger.warn('IndexedDB.open is not a function');
		return;
	}

	try {
		const originalOpen = indexedDB.open.bind(indexedDB);

		Logger.debug(`Installing IndexedDB override ${config.performConsentChecks ? 'with' : 'without'} consent checks`);

		// Use Object.defineProperty for better browser compatibility and consistency
		// with other passthrough implementations (document.cookie, localStorage/sessionStorage)
		Object.defineProperty(indexedDB, 'open', {
			value: config.performConsentChecks ? getIndexedDBOpenOverride(originalOpen) : getIndexedDBOpenOverrideEventOnly(originalOpen),
			writable: true,
			configurable: true,
		});

		Logger.debug('IndexedDB open override installed');
	} catch (e: any) {
		Logger.error(`Failed to install IndexedDB open override. ${e.message || ''}`);
	}
};
